
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1x5xj_189",
  "refresh": "awsui_refresh_1r9lg_1x5xj_189",
  "animating": "awsui_animating_1r9lg_1x5xj_203",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_1x5xj_226",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_1x5xj_230",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_1x5xj_233",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_1x5xj_236",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_1x5xj_240",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_1x5xj_243",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_1x5xj_246",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_1x5xj_249",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_1x5xj_252",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_1x5xj_256",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_1x5xj_259",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_1x5xj_262",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_1x5xj_265",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_1x5xj_268",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_1x5xj_272",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_1x5xj_275",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_1x5xj_278",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_1x5xj_281",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_1x5xj_284",
  "resize-active": "awsui_resize-active_1r9lg_1x5xj_289",
  "resize-side": "awsui_resize-side_1r9lg_1x5xj_295",
  "resize-bottom": "awsui_resize-bottom_1r9lg_1x5xj_298",
  "root": "awsui_root_1r9lg_1x5xj_303",
  "preferences-button": "awsui_preferences-button_1r9lg_1x5xj_314",
  "close-button": "awsui_close-button_1r9lg_1x5xj_318",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1x5xj_329",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1x5xj_334",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1x5xj_354",
  "position-bottom": "awsui_position-bottom_1r9lg_1x5xj_363",
  "position-side": "awsui_position-side_1r9lg_1x5xj_390",
  "slider": "awsui_slider_1r9lg_1x5xj_396",
  "slider-side": "awsui_slider-side_1r9lg_1x5xj_424",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1x5xj_429",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1x5xj_440",
  "open-button": "awsui_open-button_1r9lg_1x5xj_451",
  "open-button-side": "awsui_open-button-side_1r9lg_1x5xj_455",
  "slider-icon": "awsui_slider-icon_1r9lg_1x5xj_462",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_1x5xj_468",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_1x5xj_471",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1x5xj_475",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1x5xj_485",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1x5xj_488",
  "content-bottom": "awsui_content-bottom_1r9lg_1x5xj_496",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1x5xj_507",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1x5xj_512",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1x5xj_516",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1x5xj_520",
  "content-side": "awsui_content-side_1r9lg_1x5xj_525",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1x5xj_536",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1x5xj_539",
  "header": "awsui_header_1r9lg_1x5xj_544",
  "header-text": "awsui_header-text_1r9lg_1x5xj_553",
  "header-divider": "awsui_header-divider_1r9lg_1x5xj_561",
  "header-actions": "awsui_header-actions_1r9lg_1x5xj_567",
  "divider": "awsui_divider_1r9lg_1x5xj_575"
};
  